import { useContent } from "../contexts/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const s = content?.settings || {};
  const f = content?.footer || {};
  if (f.enabled === false) return null;

  const linkGroups = f.link_groups || [];
  const showContact = f.show_contact_block !== false;

  return (
    <footer className="bg-[#0f172a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            {s.logo_url && <img src={s.logo_url} alt={s.institute_name} className="h-12 w-auto bg-white rounded-lg p-1" />}
            <div>
              <div className="font-display text-xl font-semibold">{s.short_name || 'Sunbright'}</div>
              {(s.tagline ?? "Pharma Academy") && (
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/60">{s.tagline ?? "Pharma Academy"}</div>
              )}
            </div>
          </div>
          {f.description && (
            <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-md">{f.description}</p>
          )}
          {showContact && (
            <div className="mt-6 space-y-2 text-sm text-white/80">
              {s.address && <div data-testid="footer-address">{s.address}</div>}
              {s.phone_display && <div data-testid="footer-phone">{s.phone_display}</div>}
              {s.email && <div data-testid="footer-email">{s.email}</div>}
            </div>
          )}
        </div>

        {linkGroups.map((g, gi) => (
          <div key={`${g.title}-${gi}`} className="lg:col-span-2">
            <div className="overline" style={{ color: "rgba(255,255,255,0.6)" }}>{g.title}</div>
            <ul className="mt-4 space-y-2">
              {(g.links || []).map((l, li) => (
                <li key={`${l.label}-${li}`}>
                  <a
                    href={l.href}
                    target={l.href && l.href.startsWith("http") ? "_blank" : undefined}
                    rel={l.href && l.href.startsWith("http") ? "noopener noreferrer" : undefined}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="lg:col-span-3">
          {f.side_eyebrow && (
            <div className="overline" style={{ color: "rgba(255,255,255,0.6)" }}>{f.side_eyebrow}</div>
          )}
          {f.side_body && (
            <p className="mt-4 text-sm text-white/70 leading-relaxed">{f.side_body}</p>
          )}
          {f.staff_login_label && (
            <a
              href="/admin/login"
              data-testid="footer-admin-link"
              className="mt-6 inline-block text-xs uppercase tracking-widest text-white/40 hover:text-white/80 transition-colors"
            >
              {f.staff_login_label}
            </a>
          )}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} {s.institute_name || 'Sunbright Pharma Academy'}. {f.copyright_text || 'All rights reserved.'}</div>
          {f.tagline_line && <div>{f.tagline_line}</div>}
        </div>
      </div>
    </footer>
  );
}
